/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as CandidateRouteImport } from './routes/candidate'
import { Route as CompanyRouteImport } from './routes/company'
import { Route as EmployerRouteImport } from './routes/employer'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as RecruitRouteImport } from './routes/recruit'
import { Route as RefundRouteImport } from './routes/refund'
import { Route as SeekerRouteImport } from './routes/seeker'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminCompaniesRouteImport } from './routes/admin.companies'
import { Route as AdminJobsRouteImport } from './routes/admin.jobs'
import { Route as AdminPaymentsRouteImport } from './routes/admin.payments'
import { Route as AdminPeopleRouteImport } from './routes/admin.people'
import { Route as AdminLoginRouteImport } from './routes/admin_.login'
import { Route as CandidateIndexRouteImport } from './routes/candidate.index'
import { Route as CandidateApplicationsRouteImport } from './routes/candidate.applications'
import { Route as CandidateMessagesRouteImport } from './routes/candidate.messages'
import { Route as CandidateNotificationsRouteImport } from './routes/candidate.notifications'
import { Route as CandidateProfileRouteImport } from './routes/candidate.profile'
import { Route as CandidateSavedRouteImport } from './routes/candidate.saved'
import { Route as CandidateSettingsRouteImport } from './routes/candidate.settings'
import { Route as CompaniesCompanyIdRouteImport } from './routes/companies.$companyId'
import { Route as CompanySplatRouteImport } from './routes/company.$'
import { Route as EmployerSplatRouteImport } from './routes/employer.$'
import { Route as HackathonsIndexRouteImport } from './routes/hackathons.index'
import { Route as HackathonsHackathonIdRouteImport } from './routes/hackathons.$hackathonId'
import { Route as JobsIndexRouteImport } from './routes/jobs.index'
import { Route as JobsJobIdRouteImport } from './routes/jobs.$jobId'
import { Route as JobsJoinRouteImport } from './routes/jobs_.join'
import { Route as OnboardingCandidateRouteImport } from './routes/onboarding.candidate'
import { Route as OnboardingCompanyRouteImport } from './routes/onboarding.company'
import { Route as OnboardingRoleRouteImport } from './routes/onboarding.role'
import { Route as RecruitIndexRouteImport } from './routes/recruit.index'
import { Route as RecruitApplicantsRouteImport } from './routes/recruit.applicants'
import { Route as RecruitHackathonsRouteImport } from './routes/recruit.hackathons'
import { Route as RecruitJobsRouteImport } from './routes/recruit.jobs'
import { Route as RecruitMessagesRouteImport } from './routes/recruit.messages'
import { Route as RecruitNotificationsRouteImport } from './routes/recruit.notifications'
import { Route as RecruitProfileRouteImport } from './routes/recruit.profile'
import { Route as RecruitSettingsRouteImport } from './routes/recruit.settings'
import { Route as RecruitTalentRouteImport } from './routes/recruit.talent'
import { Route as RecruitTeamRouteImport } from './routes/recruit.team'
import { Route as RecruitInviteRouteImport } from './routes/recruit_.invite'
import { Route as RecruitJoinRouteImport } from './routes/recruit_.join'
import { Route as RecruitVerifyRouteImport } from './routes/recruit_.verify'
import { Route as SeekerSplatRouteImport } from './routes/seeker.$'
import { Route as CandidateSettingsIndexRouteImport } from './routes/candidate.settings.index'
import { Route as CandidateSettingsProfileRouteImport } from './routes/candidate.settings.profile'
import { Route as CandidateSettingsSupportRouteImport } from './routes/candidate.settings.support'
import { Route as JobsBrowseIndexRouteImport } from './routes/jobs_.browse.index'
import { Route as JobsBrowseJobIdRouteImport } from './routes/jobs_.browse.$jobId'
import { Route as RecruitHackathonsHackathonIdRouteImport } from './routes/recruit.hackathons_.$hackathonId'
import { Route as RecruitHackathonsNewRouteImport } from './routes/recruit.hackathons_.new'
import { Route as RecruitJobsJobIdRouteImport } from './routes/recruit.jobs_.$jobId'
import { Route as RecruitJobsNewRouteImport } from './routes/recruit.jobs_.new'
import { Route as RecruitSettingsIndexRouteImport } from './routes/recruit.settings.index'
import { Route as RecruitSettingsAccountRouteImport } from './routes/recruit.settings.account'
import { Route as RecruitSettingsCompanyRouteImport } from './routes/recruit.settings.company'
import { Route as RecruitSettingsSupportRouteImport } from './routes/recruit.settings.support'
import { Route as RecruitSettingsTeamRouteImport } from './routes/recruit.settings.team'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const CandidateRoute = CandidateRouteImport.update({
  id: '/candidate',
  path: '/candidate',
  getParentRoute: () => rootRouteImport,
} as any)
const CompanyRoute = CompanyRouteImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => rootRouteImport,
} as any)
const EmployerRoute = EmployerRouteImport.update({
  id: '/employer',
  path: '/employer',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const RecruitRoute = RecruitRouteImport.update({
  id: '/recruit',
  path: '/recruit',
  getParentRoute: () => rootRouteImport,
} as any)
const RefundRoute = RefundRouteImport.update({
  id: '/refund',
  path: '/refund',
  getParentRoute: () => rootRouteImport,
} as any)
const SeekerRoute = SeekerRouteImport.update({
  id: '/seeker',
  path: '/seeker',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCompaniesRoute = AdminCompaniesRouteImport.update({
  id: '/companies',
  path: '/companies',
  getParentRoute: () => AdminRoute,
} as any)
const AdminJobsRoute = AdminJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPaymentsRoute = AdminPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPeopleRoute = AdminPeopleRouteImport.update({
  id: '/people',
  path: '/people',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLoginRoute = AdminLoginRouteImport.update({
  id: '/admin_/login',
  path: '/admin/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CandidateIndexRoute = CandidateIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CandidateRoute,
} as any)
const CandidateApplicationsRoute = CandidateApplicationsRouteImport.update({
  id: '/applications',
  path: '/applications',
  getParentRoute: () => CandidateRoute,
} as any)
const CandidateMessagesRoute = CandidateMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => CandidateRoute,
} as any)
const CandidateNotificationsRoute = CandidateNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => CandidateRoute,
} as any)
const CandidateProfileRoute = CandidateProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => CandidateRoute,
} as any)
const CandidateSavedRoute = CandidateSavedRouteImport.update({
  id: '/saved',
  path: '/saved',
  getParentRoute: () => CandidateRoute,
} as any)
const CandidateSettingsRoute = CandidateSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => CandidateRoute,
} as any)
const CompaniesCompanyIdRoute = CompaniesCompanyIdRouteImport.update({
  id: '/companies/$companyId',
  path: '/companies/$companyId',
  getParentRoute: () => rootRouteImport,
} as any)
const CompanySplatRoute = CompanySplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => CompanyRoute,
} as any)
const EmployerSplatRoute = EmployerSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => EmployerRoute,
} as any)
const HackathonsIndexRoute = HackathonsIndexRouteImport.update({
  id: '/hackathons/',
  path: '/hackathons/',
  getParentRoute: () => rootRouteImport,
} as any)
const HackathonsHackathonIdRoute = HackathonsHackathonIdRouteImport.update({
  id: '/hackathons/$hackathonId',
  path: '/hackathons/$hackathonId',
  getParentRoute: () => rootRouteImport,
} as any)
const JobsIndexRoute = JobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => rootRouteImport,
} as any)
const JobsJobIdRoute = JobsJobIdRouteImport.update({
  id: '/jobs/$jobId',
  path: '/jobs/$jobId',
  getParentRoute: () => rootRouteImport,
} as any)
const JobsJoinRoute = JobsJoinRouteImport.update({
  id: '/jobs_/join',
  path: '/jobs/join',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingCandidateRoute = OnboardingCandidateRouteImport.update({
  id: '/onboarding/candidate',
  path: '/onboarding/candidate',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingCompanyRoute = OnboardingCompanyRouteImport.update({
  id: '/onboarding/company',
  path: '/onboarding/company',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoleRoute = OnboardingRoleRouteImport.update({
  id: '/onboarding/role',
  path: '/onboarding/role',
  getParentRoute: () => rootRouteImport,
} as any)
const RecruitIndexRoute = RecruitIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RecruitRoute,
} as any)
const RecruitApplicantsRoute = RecruitApplicantsRouteImport.update({
  id: '/applicants',
  path: '/applicants',
  getParentRoute: () => RecruitRoute,
} as any)
const RecruitHackathonsRoute = RecruitHackathonsRouteImport.update({
  id: '/hackathons',
  path: '/hackathons',
  getParentRoute: () => RecruitRoute,
} as any)
const RecruitJobsRoute = RecruitJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => RecruitRoute,
} as any)
const RecruitMessagesRoute = RecruitMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => RecruitRoute,
} as any)
const RecruitNotificationsRoute = RecruitNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => RecruitRoute,
} as any)
const RecruitProfileRoute = RecruitProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => RecruitRoute,
} as any)
const RecruitSettingsRoute = RecruitSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => RecruitRoute,
} as any)
const RecruitTalentRoute = RecruitTalentRouteImport.update({
  id: '/talent',
  path: '/talent',
  getParentRoute: () => RecruitRoute,
} as any)
const RecruitTeamRoute = RecruitTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => RecruitRoute,
} as any)
const RecruitInviteRoute = RecruitInviteRouteImport.update({
  id: '/recruit_/invite',
  path: '/recruit/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const RecruitJoinRoute = RecruitJoinRouteImport.update({
  id: '/recruit_/join',
  path: '/recruit/join',
  getParentRoute: () => rootRouteImport,
} as any)
const RecruitVerifyRoute = RecruitVerifyRouteImport.update({
  id: '/recruit_/verify',
  path: '/recruit/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const SeekerSplatRoute = SeekerSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => SeekerRoute,
} as any)
const CandidateSettingsIndexRoute = CandidateSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CandidateSettingsRoute,
} as any)
const CandidateSettingsProfileRoute =
  CandidateSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => CandidateSettingsRoute,
  } as any)
const CandidateSettingsSupportRoute =
  CandidateSettingsSupportRouteImport.update({
    id: '/support',
    path: '/support',
    getParentRoute: () => CandidateSettingsRoute,
  } as any)
const JobsBrowseIndexRoute = JobsBrowseIndexRouteImport.update({
  id: '/jobs_/browse/',
  path: '/jobs/browse/',
  getParentRoute: () => rootRouteImport,
} as any)
const JobsBrowseJobIdRoute = JobsBrowseJobIdRouteImport.update({
  id: '/jobs_/browse/$jobId',
  path: '/jobs/browse/$jobId',
  getParentRoute: () => rootRouteImport,
} as any)
const RecruitHackathonsHackathonIdRoute =
  RecruitHackathonsHackathonIdRouteImport.update({
    id: '/hackathons_/$hackathonId',
    path: '/hackathons/$hackathonId',
    getParentRoute: () => RecruitRoute,
  } as any)
const RecruitHackathonsNewRoute = RecruitHackathonsNewRouteImport.update({
  id: '/hackathons_/new',
  path: '/hackathons/new',
  getParentRoute: () => RecruitRoute,
} as any)
const RecruitJobsJobIdRoute = RecruitJobsJobIdRouteImport.update({
  id: '/jobs_/$jobId',
  path: '/jobs/$jobId',
  getParentRoute: () => RecruitRoute,
} as any)
const RecruitJobsNewRoute = RecruitJobsNewRouteImport.update({
  id: '/jobs_/new',
  path: '/jobs/new',
  getParentRoute: () => RecruitRoute,
} as any)
const RecruitSettingsIndexRoute = RecruitSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RecruitSettingsRoute,
} as any)
const RecruitSettingsAccountRoute = RecruitSettingsAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => RecruitSettingsRoute,
} as any)
const RecruitSettingsCompanyRoute = RecruitSettingsCompanyRouteImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => RecruitSettingsRoute,
} as any)
const RecruitSettingsSupportRoute = RecruitSettingsSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => RecruitSettingsRoute,
} as any)
const RecruitSettingsTeamRoute = RecruitSettingsTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => RecruitSettingsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/candidate': typeof CandidateRouteWithChildren
  '/company': typeof CompanyRouteWithChildren
  '/employer': typeof EmployerRouteWithChildren
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/recruit': typeof RecruitRouteWithChildren
  '/refund': typeof RefundRoute
  '/seeker': typeof SeekerRouteWithChildren
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/admin/companies': typeof AdminCompaniesRoute
  '/admin/jobs': typeof AdminJobsRoute
  '/admin/payments': typeof AdminPaymentsRoute
  '/admin/people': typeof AdminPeopleRoute
  '/admin/login': typeof AdminLoginRoute
  '/candidate/applications': typeof CandidateApplicationsRoute
  '/candidate/messages': typeof CandidateMessagesRoute
  '/candidate/notifications': typeof CandidateNotificationsRoute
  '/candidate/profile': typeof CandidateProfileRoute
  '/candidate/saved': typeof CandidateSavedRoute
  '/candidate/settings': typeof CandidateSettingsRouteWithChildren
  '/companies/$companyId': typeof CompaniesCompanyIdRoute
  '/company/$': typeof CompanySplatRoute
  '/employer/$': typeof EmployerSplatRoute
  '/hackathons/$hackathonId': typeof HackathonsHackathonIdRoute
  '/jobs/$jobId': typeof JobsJobIdRoute
  '/jobs/join': typeof JobsJoinRoute
  '/onboarding/candidate': typeof OnboardingCandidateRoute
  '/onboarding/company': typeof OnboardingCompanyRoute
  '/onboarding/role': typeof OnboardingRoleRoute
  '/recruit/applicants': typeof RecruitApplicantsRoute
  '/recruit/hackathons': typeof RecruitHackathonsRoute
  '/recruit/jobs': typeof RecruitJobsRoute
  '/recruit/messages': typeof RecruitMessagesRoute
  '/recruit/notifications': typeof RecruitNotificationsRoute
  '/recruit/profile': typeof RecruitProfileRoute
  '/recruit/settings': typeof RecruitSettingsRouteWithChildren
  '/recruit/talent': typeof RecruitTalentRoute
  '/recruit/team': typeof RecruitTeamRoute
  '/recruit/invite': typeof RecruitInviteRoute
  '/recruit/join': typeof RecruitJoinRoute
  '/recruit/verify': typeof RecruitVerifyRoute
  '/seeker/$': typeof SeekerSplatRoute
  '/admin/': typeof AdminIndexRoute
  '/candidate/': typeof CandidateIndexRoute
  '/hackathons/': typeof HackathonsIndexRoute
  '/jobs/': typeof JobsIndexRoute
  '/recruit/': typeof RecruitIndexRoute
  '/candidate/settings/profile': typeof CandidateSettingsProfileRoute
  '/candidate/settings/support': typeof CandidateSettingsSupportRoute
  '/jobs/browse/$jobId': typeof JobsBrowseJobIdRoute
  '/recruit/hackathons/$hackathonId': typeof RecruitHackathonsHackathonIdRoute
  '/recruit/hackathons/new': typeof RecruitHackathonsNewRoute
  '/recruit/jobs/$jobId': typeof RecruitJobsJobIdRoute
  '/recruit/jobs/new': typeof RecruitJobsNewRoute
  '/recruit/settings/account': typeof RecruitSettingsAccountRoute
  '/recruit/settings/company': typeof RecruitSettingsCompanyRoute
  '/recruit/settings/support': typeof RecruitSettingsSupportRoute
  '/recruit/settings/team': typeof RecruitSettingsTeamRoute
  '/candidate/settings/': typeof CandidateSettingsIndexRoute
  '/jobs/browse/': typeof JobsBrowseIndexRoute
  '/recruit/settings/': typeof RecruitSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/company': typeof CompanyRouteWithChildren
  '/employer': typeof EmployerRouteWithChildren
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/refund': typeof RefundRoute
  '/seeker': typeof SeekerRouteWithChildren
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/admin/companies': typeof AdminCompaniesRoute
  '/admin/jobs': typeof AdminJobsRoute
  '/admin/payments': typeof AdminPaymentsRoute
  '/admin/people': typeof AdminPeopleRoute
  '/admin/login': typeof AdminLoginRoute
  '/candidate/applications': typeof CandidateApplicationsRoute
  '/candidate/messages': typeof CandidateMessagesRoute
  '/candidate/notifications': typeof CandidateNotificationsRoute
  '/candidate/profile': typeof CandidateProfileRoute
  '/candidate/saved': typeof CandidateSavedRoute
  '/companies/$companyId': typeof CompaniesCompanyIdRoute
  '/company/$': typeof CompanySplatRoute
  '/employer/$': typeof EmployerSplatRoute
  '/hackathons/$hackathonId': typeof HackathonsHackathonIdRoute
  '/jobs/$jobId': typeof JobsJobIdRoute
  '/jobs/join': typeof JobsJoinRoute
  '/onboarding/candidate': typeof OnboardingCandidateRoute
  '/onboarding/company': typeof OnboardingCompanyRoute
  '/onboarding/role': typeof OnboardingRoleRoute
  '/recruit/applicants': typeof RecruitApplicantsRoute
  '/recruit/hackathons': typeof RecruitHackathonsRoute
  '/recruit/jobs': typeof RecruitJobsRoute
  '/recruit/messages': typeof RecruitMessagesRoute
  '/recruit/notifications': typeof RecruitNotificationsRoute
  '/recruit/profile': typeof RecruitProfileRoute
  '/recruit/talent': typeof RecruitTalentRoute
  '/recruit/team': typeof RecruitTeamRoute
  '/recruit/invite': typeof RecruitInviteRoute
  '/recruit/join': typeof RecruitJoinRoute
  '/recruit/verify': typeof RecruitVerifyRoute
  '/seeker/$': typeof SeekerSplatRoute
  '/admin': typeof AdminIndexRoute
  '/candidate': typeof CandidateIndexRoute
  '/hackathons': typeof HackathonsIndexRoute
  '/jobs': typeof JobsIndexRoute
  '/recruit': typeof RecruitIndexRoute
  '/candidate/settings/profile': typeof CandidateSettingsProfileRoute
  '/candidate/settings/support': typeof CandidateSettingsSupportRoute
  '/jobs/browse/$jobId': typeof JobsBrowseJobIdRoute
  '/recruit/hackathons/$hackathonId': typeof RecruitHackathonsHackathonIdRoute
  '/recruit/hackathons/new': typeof RecruitHackathonsNewRoute
  '/recruit/jobs/$jobId': typeof RecruitJobsJobIdRoute
  '/recruit/jobs/new': typeof RecruitJobsNewRoute
  '/recruit/settings/account': typeof RecruitSettingsAccountRoute
  '/recruit/settings/company': typeof RecruitSettingsCompanyRoute
  '/recruit/settings/support': typeof RecruitSettingsSupportRoute
  '/recruit/settings/team': typeof RecruitSettingsTeamRoute
  '/candidate/settings': typeof CandidateSettingsIndexRoute
  '/jobs/browse': typeof JobsBrowseIndexRoute
  '/recruit/settings': typeof RecruitSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/candidate': typeof CandidateRouteWithChildren
  '/company': typeof CompanyRouteWithChildren
  '/employer': typeof EmployerRouteWithChildren
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/recruit': typeof RecruitRouteWithChildren
  '/refund': typeof RefundRoute
  '/seeker': typeof SeekerRouteWithChildren
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/admin/companies': typeof AdminCompaniesRoute
  '/admin/jobs': typeof AdminJobsRoute
  '/admin/payments': typeof AdminPaymentsRoute
  '/admin/people': typeof AdminPeopleRoute
  '/admin_/login': typeof AdminLoginRoute
  '/candidate/applications': typeof CandidateApplicationsRoute
  '/candidate/messages': typeof CandidateMessagesRoute
  '/candidate/notifications': typeof CandidateNotificationsRoute
  '/candidate/profile': typeof CandidateProfileRoute
  '/candidate/saved': typeof CandidateSavedRoute
  '/candidate/settings': typeof CandidateSettingsRouteWithChildren
  '/companies/$companyId': typeof CompaniesCompanyIdRoute
  '/company/$': typeof CompanySplatRoute
  '/employer/$': typeof EmployerSplatRoute
  '/hackathons/$hackathonId': typeof HackathonsHackathonIdRoute
  '/jobs/$jobId': typeof JobsJobIdRoute
  '/jobs_/join': typeof JobsJoinRoute
  '/onboarding/candidate': typeof OnboardingCandidateRoute
  '/onboarding/company': typeof OnboardingCompanyRoute
  '/onboarding/role': typeof OnboardingRoleRoute
  '/recruit/applicants': typeof RecruitApplicantsRoute
  '/recruit/hackathons': typeof RecruitHackathonsRoute
  '/recruit/jobs': typeof RecruitJobsRoute
  '/recruit/messages': typeof RecruitMessagesRoute
  '/recruit/notifications': typeof RecruitNotificationsRoute
  '/recruit/profile': typeof RecruitProfileRoute
  '/recruit/settings': typeof RecruitSettingsRouteWithChildren
  '/recruit/talent': typeof RecruitTalentRoute
  '/recruit/team': typeof RecruitTeamRoute
  '/recruit_/invite': typeof RecruitInviteRoute
  '/recruit_/join': typeof RecruitJoinRoute
  '/recruit_/verify': typeof RecruitVerifyRoute
  '/seeker/$': typeof SeekerSplatRoute
  '/admin/': typeof AdminIndexRoute
  '/candidate/': typeof CandidateIndexRoute
  '/hackathons/': typeof HackathonsIndexRoute
  '/jobs/': typeof JobsIndexRoute
  '/recruit/': typeof RecruitIndexRoute
  '/candidate/settings/profile': typeof CandidateSettingsProfileRoute
  '/candidate/settings/support': typeof CandidateSettingsSupportRoute
  '/jobs_/browse/$jobId': typeof JobsBrowseJobIdRoute
  '/recruit/hackathons_/$hackathonId': typeof RecruitHackathonsHackathonIdRoute
  '/recruit/hackathons_/new': typeof RecruitHackathonsNewRoute
  '/recruit/jobs_/$jobId': typeof RecruitJobsJobIdRoute
  '/recruit/jobs_/new': typeof RecruitJobsNewRoute
  '/recruit/settings/account': typeof RecruitSettingsAccountRoute
  '/recruit/settings/company': typeof RecruitSettingsCompanyRoute
  '/recruit/settings/support': typeof RecruitSettingsSupportRoute
  '/recruit/settings/team': typeof RecruitSettingsTeamRoute
  '/candidate/settings/': typeof CandidateSettingsIndexRoute
  '/jobs_/browse/': typeof JobsBrowseIndexRoute
  '/recruit/settings/': typeof RecruitSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/candidate'
    | '/company'
    | '/employer'
    | '/login'
    | '/privacy'
    | '/recruit'
    | '/refund'
    | '/seeker'
    | '/signup'
    | '/terms'
    | '/admin/companies'
    | '/admin/jobs'
    | '/admin/payments'
    | '/admin/people'
    | '/admin/login'
    | '/candidate/applications'
    | '/candidate/messages'
    | '/candidate/notifications'
    | '/candidate/profile'
    | '/candidate/saved'
    | '/candidate/settings'
    | '/companies/$companyId'
    | '/company/$'
    | '/employer/$'
    | '/hackathons/$hackathonId'
    | '/jobs/$jobId'
    | '/jobs/join'
    | '/onboarding/candidate'
    | '/onboarding/company'
    | '/onboarding/role'
    | '/recruit/applicants'
    | '/recruit/hackathons'
    | '/recruit/jobs'
    | '/recruit/messages'
    | '/recruit/notifications'
    | '/recruit/profile'
    | '/recruit/settings'
    | '/recruit/talent'
    | '/recruit/team'
    | '/recruit/invite'
    | '/recruit/join'
    | '/recruit/verify'
    | '/seeker/$'
    | '/admin/'
    | '/candidate/'
    | '/hackathons/'
    | '/jobs/'
    | '/recruit/'
    | '/candidate/settings/profile'
    | '/candidate/settings/support'
    | '/jobs/browse/$jobId'
    | '/recruit/hackathons/$hackathonId'
    | '/recruit/hackathons/new'
    | '/recruit/jobs/$jobId'
    | '/recruit/jobs/new'
    | '/recruit/settings/account'
    | '/recruit/settings/company'
    | '/recruit/settings/support'
    | '/recruit/settings/team'
    | '/candidate/settings/'
    | '/jobs/browse/'
    | '/recruit/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/company'
    | '/employer'
    | '/login'
    | '/privacy'
    | '/refund'
    | '/seeker'
    | '/signup'
    | '/terms'
    | '/admin/companies'
    | '/admin/jobs'
    | '/admin/payments'
    | '/admin/people'
    | '/admin/login'
    | '/candidate/applications'
    | '/candidate/messages'
    | '/candidate/notifications'
    | '/candidate/profile'
    | '/candidate/saved'
    | '/companies/$companyId'
    | '/company/$'
    | '/employer/$'
    | '/hackathons/$hackathonId'
    | '/jobs/$jobId'
    | '/jobs/join'
    | '/onboarding/candidate'
    | '/onboarding/company'
    | '/onboarding/role'
    | '/recruit/applicants'
    | '/recruit/hackathons'
    | '/recruit/jobs'
    | '/recruit/messages'
    | '/recruit/notifications'
    | '/recruit/profile'
    | '/recruit/talent'
    | '/recruit/team'
    | '/recruit/invite'
    | '/recruit/join'
    | '/recruit/verify'
    | '/seeker/$'
    | '/admin'
    | '/candidate'
    | '/hackathons'
    | '/jobs'
    | '/recruit'
    | '/candidate/settings/profile'
    | '/candidate/settings/support'
    | '/jobs/browse/$jobId'
    | '/recruit/hackathons/$hackathonId'
    | '/recruit/hackathons/new'
    | '/recruit/jobs/$jobId'
    | '/recruit/jobs/new'
    | '/recruit/settings/account'
    | '/recruit/settings/company'
    | '/recruit/settings/support'
    | '/recruit/settings/team'
    | '/candidate/settings'
    | '/jobs/browse'
    | '/recruit/settings'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/candidate'
    | '/company'
    | '/employer'
    | '/login'
    | '/privacy'
    | '/recruit'
    | '/refund'
    | '/seeker'
    | '/signup'
    | '/terms'
    | '/admin/companies'
    | '/admin/jobs'
    | '/admin/payments'
    | '/admin/people'
    | '/admin_/login'
    | '/candidate/applications'
    | '/candidate/messages'
    | '/candidate/notifications'
    | '/candidate/profile'
    | '/candidate/saved'
    | '/candidate/settings'
    | '/companies/$companyId'
    | '/company/$'
    | '/employer/$'
    | '/hackathons/$hackathonId'
    | '/jobs/$jobId'
    | '/jobs_/join'
    | '/onboarding/candidate'
    | '/onboarding/company'
    | '/onboarding/role'
    | '/recruit/applicants'
    | '/recruit/hackathons'
    | '/recruit/jobs'
    | '/recruit/messages'
    | '/recruit/notifications'
    | '/recruit/profile'
    | '/recruit/settings'
    | '/recruit/talent'
    | '/recruit/team'
    | '/recruit_/invite'
    | '/recruit_/join'
    | '/recruit_/verify'
    | '/seeker/$'
    | '/admin/'
    | '/candidate/'
    | '/hackathons/'
    | '/jobs/'
    | '/recruit/'
    | '/candidate/settings/profile'
    | '/candidate/settings/support'
    | '/jobs_/browse/$jobId'
    | '/recruit/hackathons_/$hackathonId'
    | '/recruit/hackathons_/new'
    | '/recruit/jobs_/$jobId'
    | '/recruit/jobs_/new'
    | '/recruit/settings/account'
    | '/recruit/settings/company'
    | '/recruit/settings/support'
    | '/recruit/settings/team'
    | '/candidate/settings/'
    | '/jobs_/browse/'
    | '/recruit/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  CandidateRoute: typeof CandidateRouteWithChildren
  CompanyRoute: typeof CompanyRouteWithChildren
  EmployerRoute: typeof EmployerRouteWithChildren
  LoginRoute: typeof LoginRoute
  PrivacyRoute: typeof PrivacyRoute
  RecruitRoute: typeof RecruitRouteWithChildren
  RefundRoute: typeof RefundRoute
  SeekerRoute: typeof SeekerRouteWithChildren
  SignupRoute: typeof SignupRoute
  TermsRoute: typeof TermsRoute
  AdminLoginRoute: typeof AdminLoginRoute
  CompaniesCompanyIdRoute: typeof CompaniesCompanyIdRoute
  HackathonsHackathonIdRoute: typeof HackathonsHackathonIdRoute
  JobsJobIdRoute: typeof JobsJobIdRoute
  JobsJoinRoute: typeof JobsJoinRoute
  OnboardingCandidateRoute: typeof OnboardingCandidateRoute
  OnboardingCompanyRoute: typeof OnboardingCompanyRoute
  OnboardingRoleRoute: typeof OnboardingRoleRoute
  RecruitInviteRoute: typeof RecruitInviteRoute
  RecruitJoinRoute: typeof RecruitJoinRoute
  RecruitVerifyRoute: typeof RecruitVerifyRoute
  HackathonsIndexRoute: typeof HackathonsIndexRoute
  JobsIndexRoute: typeof JobsIndexRoute
  JobsBrowseJobIdRoute: typeof JobsBrowseJobIdRoute
  JobsBrowseIndexRoute: typeof JobsBrowseIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/candidate': {
      id: '/candidate'
      path: '/candidate'
      fullPath: '/candidate'
      preLoaderRoute: typeof CandidateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/company': {
      id: '/company'
      path: '/company'
      fullPath: '/company'
      preLoaderRoute: typeof CompanyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employer': {
      id: '/employer'
      path: '/employer'
      fullPath: '/employer'
      preLoaderRoute: typeof EmployerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recruit': {
      id: '/recruit'
      path: '/recruit'
      fullPath: '/recruit'
      preLoaderRoute: typeof RecruitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/refund': {
      id: '/refund'
      path: '/refund'
      fullPath: '/refund'
      preLoaderRoute: typeof RefundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/seeker': {
      id: '/seeker'
      path: '/seeker'
      fullPath: '/seeker'
      preLoaderRoute: typeof SeekerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/companies': {
      id: '/admin/companies'
      path: '/companies'
      fullPath: '/admin/companies'
      preLoaderRoute: typeof AdminCompaniesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/jobs': {
      id: '/admin/jobs'
      path: '/jobs'
      fullPath: '/admin/jobs'
      preLoaderRoute: typeof AdminJobsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/payments': {
      id: '/admin/payments'
      path: '/payments'
      fullPath: '/admin/payments'
      preLoaderRoute: typeof AdminPaymentsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/people': {
      id: '/admin/people'
      path: '/people'
      fullPath: '/admin/people'
      preLoaderRoute: typeof AdminPeopleRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin_/login': {
      id: '/admin_/login'
      path: '/admin/login'
      fullPath: '/admin/login'
      preLoaderRoute: typeof AdminLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/candidate/': {
      id: '/candidate/'
      path: '/'
      fullPath: '/candidate/'
      preLoaderRoute: typeof CandidateIndexRouteImport
      parentRoute: typeof CandidateRoute
    }
    '/candidate/applications': {
      id: '/candidate/applications'
      path: '/applications'
      fullPath: '/candidate/applications'
      preLoaderRoute: typeof CandidateApplicationsRouteImport
      parentRoute: typeof CandidateRoute
    }
    '/candidate/messages': {
      id: '/candidate/messages'
      path: '/messages'
      fullPath: '/candidate/messages'
      preLoaderRoute: typeof CandidateMessagesRouteImport
      parentRoute: typeof CandidateRoute
    }
    '/candidate/notifications': {
      id: '/candidate/notifications'
      path: '/notifications'
      fullPath: '/candidate/notifications'
      preLoaderRoute: typeof CandidateNotificationsRouteImport
      parentRoute: typeof CandidateRoute
    }
    '/candidate/profile': {
      id: '/candidate/profile'
      path: '/profile'
      fullPath: '/candidate/profile'
      preLoaderRoute: typeof CandidateProfileRouteImport
      parentRoute: typeof CandidateRoute
    }
    '/candidate/saved': {
      id: '/candidate/saved'
      path: '/saved'
      fullPath: '/candidate/saved'
      preLoaderRoute: typeof CandidateSavedRouteImport
      parentRoute: typeof CandidateRoute
    }
    '/candidate/settings': {
      id: '/candidate/settings'
      path: '/settings'
      fullPath: '/candidate/settings'
      preLoaderRoute: typeof CandidateSettingsRouteImport
      parentRoute: typeof CandidateRoute
    }
    '/companies/$companyId': {
      id: '/companies/$companyId'
      path: '/companies/$companyId'
      fullPath: '/companies/$companyId'
      preLoaderRoute: typeof CompaniesCompanyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/company/$': {
      id: '/company/$'
      path: '/$'
      fullPath: '/company/$'
      preLoaderRoute: typeof CompanySplatRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/employer/$': {
      id: '/employer/$'
      path: '/$'
      fullPath: '/employer/$'
      preLoaderRoute: typeof EmployerSplatRouteImport
      parentRoute: typeof EmployerRoute
    }
    '/hackathons/': {
      id: '/hackathons/'
      path: '/hackathons'
      fullPath: '/hackathons/'
      preLoaderRoute: typeof HackathonsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hackathons/$hackathonId': {
      id: '/hackathons/$hackathonId'
      path: '/hackathons/$hackathonId'
      fullPath: '/hackathons/$hackathonId'
      preLoaderRoute: typeof HackathonsHackathonIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs/': {
      id: '/jobs/'
      path: '/jobs'
      fullPath: '/jobs/'
      preLoaderRoute: typeof JobsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs/$jobId': {
      id: '/jobs/$jobId'
      path: '/jobs/$jobId'
      fullPath: '/jobs/$jobId'
      preLoaderRoute: typeof JobsJobIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs_/join': {
      id: '/jobs_/join'
      path: '/jobs/join'
      fullPath: '/jobs/join'
      preLoaderRoute: typeof JobsJoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/candidate': {
      id: '/onboarding/candidate'
      path: '/onboarding/candidate'
      fullPath: '/onboarding/candidate'
      preLoaderRoute: typeof OnboardingCandidateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/company': {
      id: '/onboarding/company'
      path: '/onboarding/company'
      fullPath: '/onboarding/company'
      preLoaderRoute: typeof OnboardingCompanyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/role': {
      id: '/onboarding/role'
      path: '/onboarding/role'
      fullPath: '/onboarding/role'
      preLoaderRoute: typeof OnboardingRoleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recruit/': {
      id: '/recruit/'
      path: '/'
      fullPath: '/recruit/'
      preLoaderRoute: typeof RecruitIndexRouteImport
      parentRoute: typeof RecruitRoute
    }
    '/recruit/applicants': {
      id: '/recruit/applicants'
      path: '/applicants'
      fullPath: '/recruit/applicants'
      preLoaderRoute: typeof RecruitApplicantsRouteImport
      parentRoute: typeof RecruitRoute
    }
    '/recruit/hackathons': {
      id: '/recruit/hackathons'
      path: '/hackathons'
      fullPath: '/recruit/hackathons'
      preLoaderRoute: typeof RecruitHackathonsRouteImport
      parentRoute: typeof RecruitRoute
    }
    '/recruit/jobs': {
      id: '/recruit/jobs'
      path: '/jobs'
      fullPath: '/recruit/jobs'
      preLoaderRoute: typeof RecruitJobsRouteImport
      parentRoute: typeof RecruitRoute
    }
    '/recruit/messages': {
      id: '/recruit/messages'
      path: '/messages'
      fullPath: '/recruit/messages'
      preLoaderRoute: typeof RecruitMessagesRouteImport
      parentRoute: typeof RecruitRoute
    }
    '/recruit/notifications': {
      id: '/recruit/notifications'
      path: '/notifications'
      fullPath: '/recruit/notifications'
      preLoaderRoute: typeof RecruitNotificationsRouteImport
      parentRoute: typeof RecruitRoute
    }
    '/recruit/profile': {
      id: '/recruit/profile'
      path: '/profile'
      fullPath: '/recruit/profile'
      preLoaderRoute: typeof RecruitProfileRouteImport
      parentRoute: typeof RecruitRoute
    }
    '/recruit/settings': {
      id: '/recruit/settings'
      path: '/settings'
      fullPath: '/recruit/settings'
      preLoaderRoute: typeof RecruitSettingsRouteImport
      parentRoute: typeof RecruitRoute
    }
    '/recruit/talent': {
      id: '/recruit/talent'
      path: '/talent'
      fullPath: '/recruit/talent'
      preLoaderRoute: typeof RecruitTalentRouteImport
      parentRoute: typeof RecruitRoute
    }
    '/recruit/team': {
      id: '/recruit/team'
      path: '/team'
      fullPath: '/recruit/team'
      preLoaderRoute: typeof RecruitTeamRouteImport
      parentRoute: typeof RecruitRoute
    }
    '/recruit_/invite': {
      id: '/recruit_/invite'
      path: '/recruit/invite'
      fullPath: '/recruit/invite'
      preLoaderRoute: typeof RecruitInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recruit_/join': {
      id: '/recruit_/join'
      path: '/recruit/join'
      fullPath: '/recruit/join'
      preLoaderRoute: typeof RecruitJoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recruit_/verify': {
      id: '/recruit_/verify'
      path: '/recruit/verify'
      fullPath: '/recruit/verify'
      preLoaderRoute: typeof RecruitVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/seeker/$': {
      id: '/seeker/$'
      path: '/$'
      fullPath: '/seeker/$'
      preLoaderRoute: typeof SeekerSplatRouteImport
      parentRoute: typeof SeekerRoute
    }
    '/candidate/settings/': {
      id: '/candidate/settings/'
      path: '/'
      fullPath: '/candidate/settings/'
      preLoaderRoute: typeof CandidateSettingsIndexRouteImport
      parentRoute: typeof CandidateSettingsRoute
    }
    '/candidate/settings/profile': {
      id: '/candidate/settings/profile'
      path: '/profile'
      fullPath: '/candidate/settings/profile'
      preLoaderRoute: typeof CandidateSettingsProfileRouteImport
      parentRoute: typeof CandidateSettingsRoute
    }
    '/candidate/settings/support': {
      id: '/candidate/settings/support'
      path: '/support'
      fullPath: '/candidate/settings/support'
      preLoaderRoute: typeof CandidateSettingsSupportRouteImport
      parentRoute: typeof CandidateSettingsRoute
    }
    '/jobs_/browse/': {
      id: '/jobs_/browse/'
      path: '/jobs/browse'
      fullPath: '/jobs/browse/'
      preLoaderRoute: typeof JobsBrowseIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs_/browse/$jobId': {
      id: '/jobs_/browse/$jobId'
      path: '/jobs/browse/$jobId'
      fullPath: '/jobs/browse/$jobId'
      preLoaderRoute: typeof JobsBrowseJobIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recruit/hackathons_/$hackathonId': {
      id: '/recruit/hackathons_/$hackathonId'
      path: '/hackathons/$hackathonId'
      fullPath: '/recruit/hackathons/$hackathonId'
      preLoaderRoute: typeof RecruitHackathonsHackathonIdRouteImport
      parentRoute: typeof RecruitRoute
    }
    '/recruit/hackathons_/new': {
      id: '/recruit/hackathons_/new'
      path: '/hackathons/new'
      fullPath: '/recruit/hackathons/new'
      preLoaderRoute: typeof RecruitHackathonsNewRouteImport
      parentRoute: typeof RecruitRoute
    }
    '/recruit/jobs_/$jobId': {
      id: '/recruit/jobs_/$jobId'
      path: '/jobs/$jobId'
      fullPath: '/recruit/jobs/$jobId'
      preLoaderRoute: typeof RecruitJobsJobIdRouteImport
      parentRoute: typeof RecruitRoute
    }
    '/recruit/jobs_/new': {
      id: '/recruit/jobs_/new'
      path: '/jobs/new'
      fullPath: '/recruit/jobs/new'
      preLoaderRoute: typeof RecruitJobsNewRouteImport
      parentRoute: typeof RecruitRoute
    }
    '/recruit/settings/': {
      id: '/recruit/settings/'
      path: '/'
      fullPath: '/recruit/settings/'
      preLoaderRoute: typeof RecruitSettingsIndexRouteImport
      parentRoute: typeof RecruitSettingsRoute
    }
    '/recruit/settings/account': {
      id: '/recruit/settings/account'
      path: '/account'
      fullPath: '/recruit/settings/account'
      preLoaderRoute: typeof RecruitSettingsAccountRouteImport
      parentRoute: typeof RecruitSettingsRoute
    }
    '/recruit/settings/company': {
      id: '/recruit/settings/company'
      path: '/company'
      fullPath: '/recruit/settings/company'
      preLoaderRoute: typeof RecruitSettingsCompanyRouteImport
      parentRoute: typeof RecruitSettingsRoute
    }
    '/recruit/settings/support': {
      id: '/recruit/settings/support'
      path: '/support'
      fullPath: '/recruit/settings/support'
      preLoaderRoute: typeof RecruitSettingsSupportRouteImport
      parentRoute: typeof RecruitSettingsRoute
    }
    '/recruit/settings/team': {
      id: '/recruit/settings/team'
      path: '/team'
      fullPath: '/recruit/settings/team'
      preLoaderRoute: typeof RecruitSettingsTeamRouteImport
      parentRoute: typeof RecruitSettingsRoute
    }
  }
}

interface AdminRouteChildren {
  AdminCompaniesRoute: typeof AdminCompaniesRoute
  AdminJobsRoute: typeof AdminJobsRoute
  AdminPaymentsRoute: typeof AdminPaymentsRoute
  AdminPeopleRoute: typeof AdminPeopleRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminCompaniesRoute: AdminCompaniesRoute,
  AdminJobsRoute: AdminJobsRoute,
  AdminPaymentsRoute: AdminPaymentsRoute,
  AdminPeopleRoute: AdminPeopleRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface CandidateSettingsRouteChildren {
  CandidateSettingsProfileRoute: typeof CandidateSettingsProfileRoute
  CandidateSettingsSupportRoute: typeof CandidateSettingsSupportRoute
  CandidateSettingsIndexRoute: typeof CandidateSettingsIndexRoute
}

const CandidateSettingsRouteChildren: CandidateSettingsRouteChildren = {
  CandidateSettingsProfileRoute: CandidateSettingsProfileRoute,
  CandidateSettingsSupportRoute: CandidateSettingsSupportRoute,
  CandidateSettingsIndexRoute: CandidateSettingsIndexRoute,
}

const CandidateSettingsRouteWithChildren =
  CandidateSettingsRoute._addFileChildren(CandidateSettingsRouteChildren)

interface CandidateRouteChildren {
  CandidateApplicationsRoute: typeof CandidateApplicationsRoute
  CandidateMessagesRoute: typeof CandidateMessagesRoute
  CandidateNotificationsRoute: typeof CandidateNotificationsRoute
  CandidateProfileRoute: typeof CandidateProfileRoute
  CandidateSavedRoute: typeof CandidateSavedRoute
  CandidateSettingsRoute: typeof CandidateSettingsRouteWithChildren
  CandidateIndexRoute: typeof CandidateIndexRoute
}

const CandidateRouteChildren: CandidateRouteChildren = {
  CandidateApplicationsRoute: CandidateApplicationsRoute,
  CandidateMessagesRoute: CandidateMessagesRoute,
  CandidateNotificationsRoute: CandidateNotificationsRoute,
  CandidateProfileRoute: CandidateProfileRoute,
  CandidateSavedRoute: CandidateSavedRoute,
  CandidateSettingsRoute: CandidateSettingsRouteWithChildren,
  CandidateIndexRoute: CandidateIndexRoute,
}

const CandidateRouteWithChildren = CandidateRoute._addFileChildren(
  CandidateRouteChildren,
)

interface CompanyRouteChildren {
  CompanySplatRoute: typeof CompanySplatRoute
}

const CompanyRouteChildren: CompanyRouteChildren = {
  CompanySplatRoute: CompanySplatRoute,
}

const CompanyRouteWithChildren =
  CompanyRoute._addFileChildren(CompanyRouteChildren)

interface EmployerRouteChildren {
  EmployerSplatRoute: typeof EmployerSplatRoute
}

const EmployerRouteChildren: EmployerRouteChildren = {
  EmployerSplatRoute: EmployerSplatRoute,
}

const EmployerRouteWithChildren = EmployerRoute._addFileChildren(
  EmployerRouteChildren,
)

interface RecruitSettingsRouteChildren {
  RecruitSettingsAccountRoute: typeof RecruitSettingsAccountRoute
  RecruitSettingsCompanyRoute: typeof RecruitSettingsCompanyRoute
  RecruitSettingsSupportRoute: typeof RecruitSettingsSupportRoute
  RecruitSettingsTeamRoute: typeof RecruitSettingsTeamRoute
  RecruitSettingsIndexRoute: typeof RecruitSettingsIndexRoute
}

const RecruitSettingsRouteChildren: RecruitSettingsRouteChildren = {
  RecruitSettingsAccountRoute: RecruitSettingsAccountRoute,
  RecruitSettingsCompanyRoute: RecruitSettingsCompanyRoute,
  RecruitSettingsSupportRoute: RecruitSettingsSupportRoute,
  RecruitSettingsTeamRoute: RecruitSettingsTeamRoute,
  RecruitSettingsIndexRoute: RecruitSettingsIndexRoute,
}

const RecruitSettingsRouteWithChildren = RecruitSettingsRoute._addFileChildren(
  RecruitSettingsRouteChildren,
)

interface RecruitRouteChildren {
  RecruitApplicantsRoute: typeof RecruitApplicantsRoute
  RecruitHackathonsRoute: typeof RecruitHackathonsRoute
  RecruitJobsRoute: typeof RecruitJobsRoute
  RecruitMessagesRoute: typeof RecruitMessagesRoute
  RecruitNotificationsRoute: typeof RecruitNotificationsRoute
  RecruitProfileRoute: typeof RecruitProfileRoute
  RecruitSettingsRoute: typeof RecruitSettingsRouteWithChildren
  RecruitTalentRoute: typeof RecruitTalentRoute
  RecruitTeamRoute: typeof RecruitTeamRoute
  RecruitIndexRoute: typeof RecruitIndexRoute
  RecruitHackathonsHackathonIdRoute: typeof RecruitHackathonsHackathonIdRoute
  RecruitHackathonsNewRoute: typeof RecruitHackathonsNewRoute
  RecruitJobsJobIdRoute: typeof RecruitJobsJobIdRoute
  RecruitJobsNewRoute: typeof RecruitJobsNewRoute
}

const RecruitRouteChildren: RecruitRouteChildren = {
  RecruitApplicantsRoute: RecruitApplicantsRoute,
  RecruitHackathonsRoute: RecruitHackathonsRoute,
  RecruitJobsRoute: RecruitJobsRoute,
  RecruitMessagesRoute: RecruitMessagesRoute,
  RecruitNotificationsRoute: RecruitNotificationsRoute,
  RecruitProfileRoute: RecruitProfileRoute,
  RecruitSettingsRoute: RecruitSettingsRouteWithChildren,
  RecruitTalentRoute: RecruitTalentRoute,
  RecruitTeamRoute: RecruitTeamRoute,
  RecruitIndexRoute: RecruitIndexRoute,
  RecruitHackathonsHackathonIdRoute: RecruitHackathonsHackathonIdRoute,
  RecruitHackathonsNewRoute: RecruitHackathonsNewRoute,
  RecruitJobsJobIdRoute: RecruitJobsJobIdRoute,
  RecruitJobsNewRoute: RecruitJobsNewRoute,
}

const RecruitRouteWithChildren =
  RecruitRoute._addFileChildren(RecruitRouteChildren)

interface SeekerRouteChildren {
  SeekerSplatRoute: typeof SeekerSplatRoute
}

const SeekerRouteChildren: SeekerRouteChildren = {
  SeekerSplatRoute: SeekerSplatRoute,
}

const SeekerRouteWithChildren =
  SeekerRoute._addFileChildren(SeekerRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  CandidateRoute: CandidateRouteWithChildren,
  CompanyRoute: CompanyRouteWithChildren,
  EmployerRoute: EmployerRouteWithChildren,
  LoginRoute: LoginRoute,
  PrivacyRoute: PrivacyRoute,
  RecruitRoute: RecruitRouteWithChildren,
  RefundRoute: RefundRoute,
  SeekerRoute: SeekerRouteWithChildren,
  SignupRoute: SignupRoute,
  TermsRoute: TermsRoute,
  AdminLoginRoute: AdminLoginRoute,
  CompaniesCompanyIdRoute: CompaniesCompanyIdRoute,
  HackathonsHackathonIdRoute: HackathonsHackathonIdRoute,
  JobsJobIdRoute: JobsJobIdRoute,
  JobsJoinRoute: JobsJoinRoute,
  OnboardingCandidateRoute: OnboardingCandidateRoute,
  OnboardingCompanyRoute: OnboardingCompanyRoute,
  OnboardingRoleRoute: OnboardingRoleRoute,
  RecruitInviteRoute: RecruitInviteRoute,
  RecruitJoinRoute: RecruitJoinRoute,
  RecruitVerifyRoute: RecruitVerifyRoute,
  HackathonsIndexRoute: HackathonsIndexRoute,
  JobsIndexRoute: JobsIndexRoute,
  JobsBrowseJobIdRoute: JobsBrowseJobIdRoute,
  JobsBrowseIndexRoute: JobsBrowseIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
